export const environment = {
  apiUrl: 'https://api.pcis-prod.com/api/',
  apiUrls: 'https://api.pcis-prod.com/api/',
  apiKey: '12345',
  production: true,
  pageLimit: 5,
  pageLimitNew: 10,
  tenantAbbreviation: 'agency1'
};
